(function () {
  var timer;
  var re = /\/cart\/(add|change|update|clear)/;

  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart?view=fsb&t=' + Date.now(), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html.trim();
          var fresh = tmp.querySelector('[data-fsb]');
          if (!fresh) return;
          Array.prototype.forEach.call(document.querySelectorAll('[data-fsb]'), function (el) {
            el.outerHTML = fresh.outerHTML;
          });
        })
        .catch(function () {});
    }, 150);
  }

  // fetch based cart calls
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (re.test(url)) p.then(refresh, function () {});
      return p;
    };
  }

  // XHR / jQuery ajax based cart calls (old themes)
  var xOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._fsbUrl = String(url || '');
    return xOpen.apply(this, arguments);
  };
  var xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this._fsbUrl && re.test(this._fsbUrl)) this.addEventListener('load', refresh);
    return xSend.apply(this, arguments);
  };
})();